import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  ButtonDropdown,
  Card,
  CardBody,
  InputGroup,
  Label,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { putAPI_Update_HideStats } from '../../../../../constants/APIs';
import Switch from 'rc-switch';
export default function Topics({ property, propertyId }) {
  const [topics, setTopics] = useState(property?.topics || []);
  const [analyzeTicket, setAnalyzeTicket] = useState(
    property?.analyzeTicket ?? false
  );
  const handleAddEmails = () => {
    let lst = [...topics];
    lst.push('');
    setTopics(lst);
  };

  const handlRemove = (e) =>
    setTopics(topics.filter((f, index) => index !== e));

  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [hideStatData, setHideStatsData] = useState({
    hideWebWidget: false,
    isHourlyConversation: false,
    isRegionalLevel: false,
  });
  const [rateData, setRateData] = useState({
    averageDailyRate: 0,
    averageHourlyWageRate: 0,
  });

  useEffect(() => {
    if (property !== undefined) {
      if (property.hideStats !== null) {
        setHideStatsData({
          ...hideStatData,
          hideWebWidget: property?.hideStats?.hideWebWidget,
          isHourlyConversation: property?.hideStats?.isHourlyConversation,
          isRegionalLevel: property?.hideStats?.isRegionalLevel,
        });
      }
      if (
        property.averageDailyRate !== null &&
        property.averageHourlyWageRate !== null
      ) {
        setRateData({
          averageDailyRate: property?.averageDailyRate || 0,
          averageHourlyWageRate: property?.averageHourlyWageRate || 0,
        });
      }
    }
  }, [property]);

  const handleChange = (e, index) => {
    let lst = [...topics];
    lst[index] = e.target.value;
    setTopics(lst);
  };

  const handleSave = () => {
    const body = {
      ...rateData,
      hideStats: hideStatData,
      topics: topics,
      analyzeTicket: analyzeTicket,
      updater: 'Admin',
    };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_HideStats}/${propertyId}`,
      data: body,
    }).then((res) => {
      // console.log('49', res.data);
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        window.location.reload();
      }
    });
  };

  const handleSwitchChange = (value) => {
    setAnalyzeTicket(value);
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6> Topic Detection</h6>
            <span>
              Detects the main topics in conversations, helping you categorize, view, and analyze conversations by topic.{' '}
            </span>
          </div>
          <Separator className="mb-3" />

          <div className="text-left mb-2">
            <h6>
              {' '}
              <IntlMessages id="content.topics" />{' '}
            </h6>
          </div>

          {topics.map((m, index) => (
            <div className="row mt-1 ml-2 mb-2">
              <div className="col-md-9">
                <InputGroup>
                  <Input
                    value={m}
                    type="text"
                    onChange={(e) => handleChange(e, index)}
                  ></Input>
                </InputGroup>
              </div>
              <div className="col-md-3">
                <Button
                  color="danger"
                  outline
                  size="xs"
                  onClick={() => handlRemove(index)}
                >
                  -
                </Button>
              </div>
            </div>
          ))}
          <div className="row mt-1 ml-2 mb-3">
            <div className="d-flex w-100">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={handleAddEmails}
              >
                + Add Topic
              </Button>
            </div>
          </div>

          <div className="text-center mb-2">
            <div className="d-flex w-100 mt-1">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small"
                checked={analyzeTicket}
                onChange={(primary) => handleSwitchChange(primary)}
              />
              <Label className="ml-2">
                Analyze Common Questions based on Topics
              </Label>
            </div>
          </div>

          <Separator className="mb-2" />

          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"

            >
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
